import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import { T, F } from 'ramda'

import GridTile from './grid-tile'
import styles from './grid.css'

import TILE_FRAGMENT from '../../../graphql/fragments/tile.gql'

function renderTiles(
  tiles,
  contentType,
  subType,
  theme,
  gridPosition,
  listTitle,
  isContentItemOnMyList,
  addToMyList
) {
  return (tiles || []).map((tile, index) => (
    <GridTile
      // eslint-disable-next-line react/no-array-index-key
      key={`${tile.contentItem.id}-${index}`}
      tile={tile}
      theme={theme}
      contentType={contentType}
      subType={subType}
      listTitle={listTitle}
      index={index}
      gridPosition={gridPosition}
      isOnMyList={isContentItemOnMyList(tile.contentItem.id)}
      addToMyList={addToMyList}
    />
  ))
}

function GridBody({
  tiles,
  contentType,
  subType,
  theme,
  gridPosition,
  listTitle,
  isContentItemOnMyList,
  addToMyList
}) {
  return (
    <div className={styles.gridContentWrapper}>
      {renderTiles(
        tiles,
        contentType,
        subType,
        theme,
        gridPosition,
        listTitle,
        isContentItemOnMyList,
        addToMyList
      )}
    </div>
  )
}

GridBody.propTypes = {
  tiles: PropTypes.arrayOf(propType(TILE_FRAGMENT)).isRequired,
  theme: PropTypes.string.isRequired,
  contentType: PropTypes.string,
  subType: PropTypes.string,
  gridPosition: PropTypes.number.isRequired,
  listTitle: PropTypes.string.isRequired,
  isContentItemOnMyList: PropTypes.func,
  addToMyList: PropTypes.func
}

GridBody.defaultProps = {
  contentType: null,
  subType: null,
  isContentItemOnMyList: F,
  addToMyList: T
}

export default GridBody
